/*  MUI  */
import { Select, SelectOption } from '@auviknetworks/iceberg-ui';
import { Box, FormLabel, Skeleton } from '@mui/material';
import { useFetchRecipes } from 'hooks/dataAccess/Recipe/recipe';

/*  React  */
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const ApplicationSelect = ({
    clientId,
    onChange,
    value
}: {
    clientId: string;
    onChange: (applicationId: string) => void;
    value: string;
}) => {
    const { t } = useTranslation();
    const params = useMemo(
        () => ({
            includeApplication: true,
            platformTenantId: clientId,
            size: -1
        }),
        [clientId]
    );
    const { recipes, loading } = useFetchRecipes(params);

    const applicationOptions = useMemo(
        () =>
            recipes
                ?.filter((recipe) => Boolean(recipe?.application?.id))
                .map(({ application }) => ({
                    label: application!.name,
                    value: application!.id
                })) as SelectOption[],
        [recipes]
    );

    const uniqueApplicationOptions = applicationOptions
        .filter(
            (option, index, self) =>
                index === self.findIndex((t) => t.value === option.value)
        )
        .sort((a, b) => a.label!.localeCompare(b.label!));

    return loading ? (
        <Skeleton variant="rounded" height={33} width="100%" />
    ) : (
        <Box sx={{ marginTop: '16px' }}>
            <FormLabel>
                {t('Admin.FormBuilder.ContextManager.application')}
            </FormLabel>
            <Select
                name="applicationId"
                options={uniqueApplicationOptions}
                onChange={({ value }: { value: string }) => {
                    onChange(value);
                }}
                value={value}
            />
        </Box>
    );
};
